// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalProjectScopedOverview } from './InternalProjectScopedOverview';
import {
  InternalProjectScopedOverviewFromJSON,
  InternalProjectScopedOverviewFromJSONTyped,
  InternalProjectScopedOverviewToJSON,
  InternalProjectScopedOverviewToJSONTyped,
} from './InternalProjectScopedOverview';

/**
 *
 * @export
 * @interface GetInternalProjectScopedOverview200Response
 */
export interface GetInternalProjectScopedOverview200Response {
  /**
   *
   * @type {InternalProjectScopedOverview}
   * @memberof GetInternalProjectScopedOverview200Response
   */
  data: InternalProjectScopedOverview;
}

/**
 * Check if a given object implements the GetInternalProjectScopedOverview200Response interface.
 */
export function instanceOfGetInternalProjectScopedOverview200Response(
  value: object,
): value is GetInternalProjectScopedOverview200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function GetInternalProjectScopedOverview200ResponseFromJSON(
  json: any,
): GetInternalProjectScopedOverview200Response {
  return GetInternalProjectScopedOverview200ResponseFromJSONTyped(json, false);
}

export function GetInternalProjectScopedOverview200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GetInternalProjectScopedOverview200Response {
  if (json == null) {
    return json;
  }
  return {
    data: InternalProjectScopedOverviewFromJSON(json['data']),
  };
}

export function GetInternalProjectScopedOverview200ResponseToJSON(
  json: any,
): GetInternalProjectScopedOverview200Response {
  return GetInternalProjectScopedOverview200ResponseToJSONTyped(json, false);
}

export function GetInternalProjectScopedOverview200ResponseToJSONTyped(
  value?: GetInternalProjectScopedOverview200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: InternalProjectScopedOverviewToJSON(value['data']),
  };
}
